import { useEffect, useState } from "react";
import { apiClient } from "../lib/api";

/**
 * Fetch live Google Business Profile reviews + aggregateRating from the
 * backend's `/api/reviews/business` endpoint.
 *
 *  - Cache lives server-side (Mongo, 24h TTL).
 *  - 503 (not configured) → returns `{ data: null }` so caller falls back
 *    to static REVIEWS in ReviewsCarousel.
 *  - Any network error → returns `{ data: null, error }` (silent fallback).
 *
 *  Shape on success:
 *    { placeId, aggregateRating, reviewCount, reviews: [...], source }
 */
export function useGoogleReviews() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    apiClient.get("/reviews/business")
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch((e) => {
        if (cancelled) return;
        // 503 means env vars not set yet — treat as "no live data, use fallback"
        const status = e?.response?.status;
        if (status !== 503) setError(e);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { data, loading, error };
}
